(function () {
    'use strict';

    angular
        .module('core.interceptors')
        .factory('authenticationFactory', AuthenticationFactory)

    /** @ngInject */
    function AuthenticationFactory($q, $rootScope, AUTH_EVENTS, LOCAL_STORAGE_ITEMS) {
        return {
            request: request,
            responseError: responseError
        }

        function request(config) {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const selectedUnitId = localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_UNIT);

            config.headers = config.headers || {};

            if (accessToken) {
                Object.assign(config.headers, {
                    'Authorization': 'Bearer ' + accessToken
                });
            }

            // The unit picked on the top bar is the unit the user is acting on, and it is what the API
            // validates the permissions against. It can't be taken from the query string, where a unit is
            // a search filter and may point at any unit in the network.
            if (selectedUnitId) {
                Object.assign(config.headers, {
                    'X-Selected-Unit': selectedUnitId
                });
            }

            return config;
        }

        function responseError(response) {
            // Only 401 means the session is gone, and only that should drop the user back to the login.
            // Lacking permission on a resource now answers 403 and is handled by the screen itself, so
            // the user isn't logged out of a session that is still perfectly valid.
            if (response.status === 401)
                $rootScope.$broadcast(AUTH_EVENTS.NOT_AUTHENTICATED, response);

            return $q.reject(response);
        }
    }
}());